import Contacts from './components/Contacts';

export const contacts = {
  firstLevel: Contacts,
};